import {
	RETIREMENT_SAVINGS_DROP_ID,
	RetirementDropNoteType,
	RetirementDropSource,
} from "web_myplann/Inspiration/Retirement/constants";
import { mapRetirementLoanDrop } from "web_myplann/Inspiration/Retirement/Mappers/mapRetirementLoanDrop";
import { mapRetirementManualDrop } from "web_myplann/Inspiration/Retirement/Mappers/mapRetirementManualDrop";
import type {
	RetirementDrop,
	RetirementManualDrop,
	RetirementPortfolioItem,
	RetirementUncheckedDrop,
} from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

export const getRetirementDrops = (
	items: RetirementPortfolioItem[],
	extras: RetirementManualDrop[],
	retirementYear: number,
	dropsOff: string[] = [],
): RetirementDrop[] => {
	const loans = items
		.filter((item) => item.kind === "loan" && item.monthlyPayment > 0)
		.map((item) => mapRetirementLoanDrop(item, retirementYear));

	const savingsTotal = items
		.filter((item) => item.kind === "saving")
		.reduce((sum, item) => sum + item.monthlyPayment, 0);

	const savings: RetirementUncheckedDrop[] =
		savingsTotal > 0
			? [
					{
						id: RETIREMENT_SAVINGS_DROP_ID,
						label: { type: RetirementDropSource.Savings },
						amount: savingsTotal,
						deductible: true,
						note: { type: RetirementDropNoteType.Savings },
					},
				]
			: [];

	return [
		...loans,
		...savings,
		...extras.map((extra) => mapRetirementManualDrop(extra, retirementYear)),
	].map((drop) => ({
		...drop,
		checked: drop.deductible && !dropsOff.includes(drop.id),
	}));
};
